module.exports = __webpack_public_path__ + "static/media/laugh.82d4fc2a.svg";